import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import { colors } from '@/constants/theme';

type Props = {
  tags: Array<string>;
  className?: string;
};

const Tags = ({ tags, className }: Props) => {
  const t = useTranslations();
  return (
    <Component className={className}>
      <Label>{t('blog.tags')}:</Label>
      <List className="tags-list">
        {tags.map((tag, index) => (
          <Tag key={index}>{tag}</Tag>
        ))}
      </List>
    </Component>
  );
};

export default Tags;

const Component = styled.div`
  .tags-list::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 1px;
  }

  .tags-list::-webkit-scrollbar-thumb {
    position: absolute;
    top: 0;

    border-radius: 4px;
    background-color: ${colors.grayLighter};
  }
`;
const Label = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`;
const List = styled.ul`
  overflow-x: auto;
  display: flex;
  align-items: center;
  white-space: nowrap;

  & > li:not(:first-child) {
    margin-left: 1.125rem;
  }
`;
const Tag = styled.li`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: ${colors.primary};
`;
